import Environment from "./base";

const environments: Environment = {
  isDevelopment: false,
  serviceHostName: "https://alpha-service.pantavanij.com",
  clientID: "supplier",
  cookieWow: "https://cookiecdn.com/cwc.js",
  cookieWowDataDomainScript: "MLdYErs4RA5udbHHvBxewabo", // Alpha-specific config for alpha-supplier.pantavanij.com
  keycloakHostName: "https://alpha-service.pantavanij.com/keycloak",
  keycloakRealm: "ptvn",
  supplierFrontend: "https://alpha-supplier.pantavanij.com",
  supplierWebWorkFrontend: "https://supplierportal-demo.pantavanij.com",
  emarketPlaceFrontend: "https://alpha-emarketplace.pantavanij.com",
  pantavanijIntelligenceFrontend: "https://alpha-emarketplace.pantavanij.com/pi",
  lameSurvayFrontend: "https://alphacl-saq.pantavanij.com/loginFromSC",
  sqaOneFrontend: "https://staging-saq-one.pantavanij.com/dashboard?userGuid=",
  oneTrust: "https://cdn-apac.onetrust.com",
  oneTrustDataDomainScript: "455ce70e-987e-4d20-8865-0359614e5438-test",
  googleAnalyticKey: "G-5995ZCZKN3",
  // googleAnalyticKey: "G-6B9F3P4WEL",
  cocDocumentTH: "https://alpha-supplier.pantavanij.com/files/CPGCG-CoC-TH.pdf",
  cocDocumentEN: "https://alpha-supplier.pantavanij.com/files/CPGCG-CoC-EN.pdf",
  AccepAutoPOTH: "https://alpha-supplier.pantavanij.com/files/Supplier_Auto_Accept_PO_V3_Thai.pdf",
  AccepAutoPOEN: "https://alpha-supplier.pantavanij.com/files/Supplier_Auto_Accept_PO_V3_Eng.pdf",
  subOnePOA: "https://dev-poa.pantavanij.com/auth/callback?userGuid=",
  hotjar: {
    siteId: 3564227,
    hotjarVersion: 6,
  }
};

export default environments;


